import CallIcon from '@mui/icons-material/Call';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { EventChip } from '../EventChip';

export const CallEventChip = () => {
  const { t } = useTranslation();

  return (
    <div className="my-2">
      <EventChip icon={<CallIcon />} label={t('meeting:on-site-call.call')} />
    </div>
  );
};
